import angular from "angular";
import "angular-scroll";
import { extendModule } from "ng";
import ngMap from "ngmap";
import AddressInfo from "webutils/address-info";
import Panel from "webutils/panel";
import textSwitcher from "webutils/text-switcher";
//import PageTitle from 'webutils/page-title'
import "angular-ui-carousel/dist/ui-carousel.min.css";
import "angular-ui-carousel/dist/ui-carousel.min.js";
import bootswatch from "webutils/bootswatch";
import BootswatchDirectiveFactory from "webutils/bootswatch.directive";
import Datum from "webutils/datum";
import Heading from "webutils/heading";
import HeadroomDirectiveFactory from "webutils/headroom";
import HttpPollerDirectiveFactory from "webutils/http-poller.directive";
import ImagePollerDirectiveFactory from "webutils/image-poller.directive";
import JsonLd from "webutils/jsonld";
import LabeledValue from "webutils/labeled-value";
import Magic360DirectiveFactory from "webutils/magic360";
import MagicScrollDirectiveFactory from "webutils/magicscroll";
import MagicZoomDirectiveFactory from "webutils/magiczoomplus";
import MessageIcon from "webutils/message-icon";
import "webutils/scss/custom.scss";
import csvParser from "webutils/services/csv-parser";
import $dates from "webutils/services/dates";
import "webutils/services/ends-with";
import $geo from "webutils/services/geo";
import $notify from "webutils/services/notify";
import $pageConfig from "webutils/services/page-config";
import "webutils/services/starts-with";
import usaStates from "webutils/services/usa-states";
import utils from "webutils/services/util";
import "webutils/webutils.scss";
//import MaterialDesignIcons from 'bootstrap-material-design-icons/scss/material-icons.scss'
import "webutils/angular-bootstrap-lightbox";
import ImageManager from "webutils/image-manager";
import MediaManager from "webutils/media/media-manager";
import ngBindHtmlCompile from "webutils/ng-bind-html-compile";
// directives
import aHref from "webutils/directives/a-href";
import alternateImage from "webutils/directives/alternate-image";
import autoFocus from "webutils/directives/auto-focus";
import back from "webutils/directives/back";
import backgroundImage from "webutils/directives/background-image";
import capitalize from "webutils/directives/capitalize";
import contenteditable from "webutils/directives/contenteditable";
import cubePortfolio from "webutils/directives/cube-portfolio";
import eventListener from "webutils/directives/event-listener";
import focusOther from "webutils/directives/focus-other";
import getProp from "webutils/directives/get-prop";
import httpReader from "webutils/directives/http-reader";
import jqueryPlugin, { jqPlugIn } from "webutils/directives/jquery-plugin";
import { maxHeight, maxWidth } from "webutils/directives/max-size";
import ngCurrency from "webutils/directives/ng-currency";
import ngEnter from "webutils/directives/ng-enter";
import ngEnterDelay from "webutils/directives/ng-enter-delay";
import ngHold from "webutils/directives/ng-hold";
import registerImageGallery from "webutils/directives/ng-image-gallery";
import numeric from "webutils/directives/numeric";
import reloadImages from "webutils/directives/reload-images";
import selectOnFocus from "webutils/directives/select-on-focus";
import simpleCarousel from "webutils/directives/simple-carousel";
import registerSocialMediaShare from "webutils/directives/social-media-share";
import swapHover from "webutils/directives/swap-hover";
import timeoutStager from "webutils/directives/timeout-stager";
import updateOnEnter from "webutils/directives/update-on-enter";
// import yotpo from "webutils/directives/yotpo";
import scrollIntoView from "webutils/directives/scroll-into-view";
import scrollToItem from "webutils/directives/scroll-to-item";
import urlExists from "webutils/directives/url-exists";
// modules
import mediaModule from "emun.media/media.module";
import { filters } from "webutils/filters/filters.module";
import ibox from "webutils/ibox/ibox.module";
import textTruncate from "webutils/text-truncate.module";

function Run(
  $rootScope,
  $state,
  $controller,
  $geo,
  $dates,
  $location,
  googleMapsUrl
) {
  $pageConfig.init($rootScope);
  $rootScope.$pageConfig = $pageConfig;
  $rootScope.$geo = $geo;
  $rootScope.$dates = $dates;
  $rootScope.googleMapsUrl = $geo.googleMapsUrl = googleMapsUrl;
  $rootScope.$on(
    "$stateChangeSuccess",
    (event, toState, toParams, fromState, fromParams) => {
      if (toState.rerouteTo) {
        // console.debug("$stateChangeSuccess$rerouteTo", toState.rerouteTo, {
        //   event,
        //   toState,
        //   toParams,
        //   fromState,
        //   fromParams,
        // });
        return $state.go(toState.rerouteTo, toParams, {
          location: false,
        });
      }
      if (toState.rerouteProvider) {
        let redirect = $controller(toState.rerouteProvider);
        for (let state in redirect) {
          console.debug(
            "$stateChangeSuccess$rerouteProvider",
            toState.rerouteProvider,
            {
              event,
              redirect,
              toState,
              toParams,
              fromState,
              fromParams,
            }
          );
          return $state.go(state, redirect[state], { location: "replace" });
        }
      }
      $pageConfig.goTop();
      delete toState.customTitle;
      window.ga && ga("send", "pageview", location.pathname + $location.url());
    }
  );
}

export const app = angular
  .module("webutils", [
    "ngStorage",
    //"ngAnimate",
    "angular-growl",
    ngMap,
    "ui.carousel",
    "duScroll",
  ])
  .component("addressInfo", AddressInfo)
  //.component('pageTitle', PageTitle)
  .filter(
    "moment",
    () => (input, momentFn /*, param1, param2, ...param n */) => {
      const args = Array.prototype.slice.call(arguments, 2),
        momentObj = window.moment(input);
      return momentObj[momentFn].apply(momentObj, args);
    }
  )
  .factory("$notify", $notify)
  .factory("notify", $notify)
  .component("panel", Panel)
  .component("textSwitcher", textSwitcher)
  .component("jsonld", JsonLd)
  .component("labeledValue", LabeledValue)
  .component("datum", Datum)
  .component("heading", Heading)
  .component("messageIcon", MessageIcon)
  .component("imageManager", ImageManager)
  .component("mediaManager", MediaManager)
  .value("$geo", $geo)
  .value("$dates", $dates)
  .value("$pageConfig", $pageConfig)
  .value("bootswatch", bootswatch)

  .directive("capitalize", capitalize)
  .directive("contenteditable", contenteditable)
  .directive("cubePortfolio", cubePortfolio)
  .directive("eventListener", eventListener)
  .directive("focusOther", focusOther)
  .directive("swapHover", swapHover)
  .directive("httpReader", httpReader)
  .directive("jqueryPlugin", jqueryPlugin)
  .directive("jqPlugIn", jqPlugIn)
  .directive("ngCurrency", ngCurrency)
  .directive("ngEnter", ngEnter)
  .directive("ngEnterDelay", ngEnterDelay)
  .directive("ngHold", ngHold)
  .directive("numeric", numeric)
  .directive("getProp", getProp)
  .directive("reloadImages", reloadImages)
  .directive("simpleCarousel", simpleCarousel)
  .directive("updateOnEnter", updateOnEnter)
  // .directive("yotpo", yotpo)
  .directive("scrollToItem", scrollToItem)
  .directive("scrollIntoView", scrollIntoView)
  .directive("aHref", aHref)
  .directive("altImage", alternateImage)
  .directive("altImages", alternateImage)
  .directive("alternateImage", alternateImage)
  .directive("alternateImages", alternateImage)
  .directive("autoFocus", autoFocus)
  .directive("back", back)
  .directive("maxHeight", maxHeight)
  .directive("maxWidth", maxWidth)
  .directive("selectOnFocus", selectOnFocus)
  .directive("timeoutStager", timeoutStager)
  .directive("ngBindHtmlCompile", ngBindHtmlCompile)
  .directive("backgroundImage", backgroundImage)
  .directive("headroom", HeadroomDirectiveFactory)
  .directive("magicZoom", MagicZoomDirectiveFactory)
  .directive("magiczoom", MagicZoomDirectiveFactory)
  .directive("magicscroll", MagicScrollDirectiveFactory)
  .directive("magicspin", Magic360DirectiveFactory)
  .directive("magic360", Magic360DirectiveFactory)
  .directive("bootswatch", BootswatchDirectiveFactory)
  .directive("imagePoller", ImagePollerDirectiveFactory)
  .directive("urlExists", urlExists)
  .directive("vbox", () => ({
    link(scope, element, attrs) {
      attrs.$observe("vbox", function (value) {
        element.attr("viewBox", value);
        element[0].setAttribute("viewBox", value);
      });
    },
  }))
  .directive("relocateElements", () => ({
    // restrict: "A",
    link(scope, element, attrs) {
      const matchingElements = document.querySelectorAll(
        attrs.relocateElements || attrs.selector|| attrs.selectors
      );
      for (let i = 0; i < matchingElements.length; i++) {
        element.append(matchingElements[i]);
      }
    },
  }))
  .directive("httpPoller", HttpPollerDirectiveFactory)
  .run(Run)
  .value("util", utils)
  .value("utils", utils)
  .value("usaStates", usaStates)
  .value("csvParser", csvParser)
  .constant(
    "googleMapsUrl",
    "https://maps.googleapis.com/maps/api/js?key=AIzaSyALMtF7jirmQSaowmNd9PuIVFGCzxnBdYM&callback=googleMapsReady"
  );
//	.constant('googleMapsUrl', 'https://maps.googleapis.com/maps/api/js?key=AIzaSyALMtF7jirmQSaowmNd9PuIVFGCzxnBdYM&callback=googleMapsReady');

//console.log("registerImageGallery", registerImageGallery, app);
registerImageGallery(app);
registerSocialMediaShare(app);
extendModule(app, mediaModule, textTruncate, ibox);

for (const fn in filters) {
  app.filter(fn, filters[fn]);
}

export default app.name;
